export enum LocalStorageKeys {
  VideoCallData = 'video_call_data',
  VideoCallFlowCustomizationParams = 'video_call_flow_customization_params',
  UserData = 'user_data',
  UtmParams = 'utm_params',
  OwnSensorV2Data = 'own_sensor_v2_data',
  PartnerFlowData = 'partner_flow_data',
  PartnerFlowPromoCode = 'partner_flow_promo_code',
  UhcOnboardingData = 'uhc_onboarding_data',
  OnboardingData = 'onboarding_data',
  InsuranceQuestionnaireState = 'insurance_questionnaire_state'
}
